module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImg1.e1d96ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImg1.jpg
// module id = /L84
// module chunks = 6